import { useShopInfos } from "~/store/shopInfosStore";
export const getRouteWithprefix = (route) => {
    const shopInfoStore = useShopInfos();
    return ["", shopInfoStore.getShopdirectoryLocalized, shopInfoStore.shopname].join("/") + (route !== "" ? "/" + route : "");
};
export const getRouteToHome = () => getRouteWithprefix("");
//# sourceMappingURL=routeUtils.js.map